import { NavigationBar, TabItem } from 'selfly-ui-react';
import React, { useEffect } from 'react';
import { useHistory, withRouter } from 'react-router-dom';
import { storeRedirectPath } from '../../localStorage.js';
import { CLASSIC_DISCOUNTS_PATH, discountsHomePath, newDiscountApiEnabled } from '../../services/discountSource.js';
import { fetchDiscountRollout } from '../../actions/discountRollout.js';

import { connect } from 'react-redux';
import { translate } from 'react-i18next';

export function Navigation(props) {
    const history = useHistory();
    const { t, user, location, discountsPath, newDiscountApi, fetchDiscountRollout } = props;
    const groupId = user && user.group && user.group.Id;
    const seesDiscounts = Boolean(user && (user.isAdmin || user.isReportingOperator));

    // Read the organization's discount rollout flag up front, so the Discounts tab already points at the right page.
    useEffect(() => {
        if (groupId && seesDiscounts) {
            fetchDiscountRollout();
        }
    }, [groupId, seesDiscounts, fetchDiscountRollout]);

    function isActivePath(path) {
        return history.location.pathname === path;
    }

    function isVisibleToUser(user, readOnly = false, refillManagementPage = false) {
        const roles = user.profile.roles;
        const allowedRolesForVisibility = ['Cabinet Operator', 'Administrator'];
        if (refillManagementPage) {
            allowedRolesForVisibility.push('Refill Operator');
        }
        if (readOnly) {
            allowedRolesForVisibility.push('Reporting Operator');
        }
        const visibility = (Array.isArray(roles) ? roles.filter(role => allowedRolesForVisibility.includes(role)) : []).length > 0;
        return visibility;
    }

    function redirectTo(path) {
        history.push(path);
        storeRedirectPath(path);
    }

    return (
        <div className="scp-navigation-bar">
            {!location.pathname.includes('settings-consumer-app') &&
                !location.pathname.includes('software-versions') &&
                !location.pathname.includes('automations') &&
                !location.pathname.includes('consumers') && (
                <NavigationBar>
                    {isVisibleToUser(user, true) && (
                        <TabItem onClick={redirectTo.bind(this, '/analytics')} isActive={isActivePath.call(this, '/analytics')}>
                            <span>{t('analytics')}</span>
                        </TabItem>
                    )}
                    <TabItem onClick={redirectTo.bind(this, '/devices')} isActive={isActivePath.call(this, '/devices')}>
                        <span>{t('deviceManagement')}</span>
                    </TabItem>
                    {isVisibleToUser(user, true) && (
                        <TabItem onClick={redirectTo.bind(this, '/advertisements')} isActive={isActivePath.call(this, '/advertisements')}>
                            <span>{t('advertisements')}</span>
                        </TabItem>
                    )}
                    <TabItem onClick={redirectTo.bind(this, '/products')} isActive={isActivePath.call(this, '/products')}>
                        <span>{t('productCatalog')}</span>
                    </TabItem>
                    {isVisibleToUser(user, true) && (
                        <TabItem onClick={redirectTo.bind(this, discountsPath)} isActive={isActivePath.call(this, discountsPath)}>
                            <span>{t('discounts')}</span>
                        </TabItem>
                    )}
                    {/* Only while you are on it. The classic page is entered from the gear menu, so it needs
                      * no permanent tab — but marking the regular Discounts tab active would say you are on a
                      * page you are not. Its own tab labels where you actually are, and the Discounts tab
                      * beside it stays inactive as the way back. Self-navigating on click deliberately skips
                      * `redirectTo`, which would persist this as the post-login landing page.
                      * Only for an organization switched to the discount service: otherwise the Discounts tab itself
                      * opens the classic page. */}
                    {isVisibleToUser(user, true) && newDiscountApi === true && isActivePath.call(this, CLASSIC_DISCOUNTS_PATH) && (
                        <TabItem onClick={() => history.push(CLASSIC_DISCOUNTS_PATH)} isActive={true}>
                            <span>{t('classicDiscounts')}</span>
                        </TabItem>
                    )}
                    {isVisibleToUser(user, true, true) && (
                        <TabItem onClick={redirectTo.bind(this, '/refill-plans')} isActive={isActivePath.call(this, '/refill-plans')}>
                            <span>{t('refillManagement')}</span>
                        </TabItem>
                    )}
                    <TabItem onClick={() => window.open('https://community.selflystore.com', '_blank', 'noopener')} isActive={false}>
                        <span>{t('community')}</span>
                        <i className="ml-1 fas fa-external-link-alt"></i>
                    </TabItem>
                </NavigationBar>
            )}
        </div>
    );
}

export default withRouter(
    connect(
        state => ({
            user: state.user,
            discountsPath: discountsHomePath(state),
            newDiscountApi: newDiscountApiEnabled(state),
        }),
        { fetchDiscountRollout }
    )(translate('navigation')(Navigation))
);
